import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Catalog } from '@cureskin/api-client/src/server-api';
import { AllocatedRegimen } from '../../../app-constant-types';
import { SwiperModule } from 'swiper/angular';
import { ProductComponent } from '../product/product.component';
import { ProductSize } from '../product/product.types';
import { BuyCompleteKitBannerComponent } from '../buy-complete-kit-banner/buy-complete-kit-banner.component';
import { RegimenClass } from '../../unpaid-user-shop/unpaid-user-shop.types';

@Component({
  selector: 'app-regimen-products-list',
  imports: [ProductComponent, BuyCompleteKitBannerComponent, SwiperModule],
  templateUrl: './regimen-products-list.component.html',
  host: { class: 'tw-block tw-bg-gradient-teal-top-to-white' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegimenProductsListComponent {
  readonly ProductSize = ProductSize;
  readonly RegimenClass = RegimenClass;
  products = input<Array<Catalog & { isLocked?: boolean }>>([]);
  userName = input<string>('');
  userPhoto = input<string>('');
  productsInCart = input<{ [key: string]: number }>({});
  regimens = input<AllocatedRegimen[]>([]);
  activeRegimenClass = input<RegimenClass>();
  productCardsVariant = input<boolean>(false);

  renderBullet = (index: number, className: string): string => `<span class="${className}"></span>`;

  addToCart = output<{ product: Catalog; image: HTMLImageElement }>();
  removeFromCart = output<Catalog>();
  buyKit = output<AllocatedRegimen>();
  gotoProduct = output<Catalog>();

  onAddToCart(event: { product: Catalog; image: HTMLImageElement }): void {
    this.addToCart.emit(event);
  }

  onRemoveFromCart(product: Catalog): void {
    this.removeFromCart.emit(product);
  }

  onBuyKit(regimen: AllocatedRegimen): void {
    this.buyKit.emit(regimen);
  }

  onGotoProduct(product: Catalog): void {
    this.gotoProduct.emit(product);
  }
}
